// Floating time model utilities
const FIXED_TZ = 'UTC';

export function getUserTimezone(): string {
  // Always UTC in floating-time model
  return FIXED_TZ;
}

function parseDate(value: string | Date): Date {
  if (value instanceof Date) return new Date(value);
  if (!value) return new Date(NaN);
  let s = String(value).trim();
  if (!s) return new Date(NaN);
  s = s.replace(' ', 'T');
  if (/Z|[+-]\d{2}:?\d{2}$/.test(s)) {
    return new Date(s);
  }
  const [datePart, timePart = ''] = s.split('T');
  const [yy, mm, dd] = datePart.split('-').map(Number);
  const [HH = 0, MM = 0, SS = 0] = timePart.split(':').map(Number);
  if (!yy || !mm || !dd) return new Date(NaN);
  // Represent local wall time as a UTC instant to preserve displayed HH:MM
  const base = new Date(Date.UTC(yy, (mm || 1) - 1, dd || 1, HH || 0, MM || 0, SS || 0));
  return base;
}

export function formatDate(value: string | Date, opts: Intl.DateTimeFormatOptions = {}) {
  const d = parseDate(value);
  if (isNaN(d.getTime())) return '';
  return new Intl.DateTimeFormat('pt-BR', { timeZone: getUserTimezone(), hour12: false, ...opts }).format(d);
}

export function formatTime(value: string | Date, opts: Intl.DateTimeFormatOptions = {}) {
  return formatDate(value, { hour: '2-digit', minute: '2-digit', hour12: false, ...opts });
}

export function formatDateTime(value: string | Date, opts: Intl.DateTimeFormatOptions = {}) {
  return formatDate(value, { dateStyle: 'short', timeStyle: 'short', ...opts });
}

export function parseBrazilDate(value: string | Date): Date {
  return parseDate(value);
}
